/* tslint:disable */
import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {Subscription} from "rxjs";
import {Pending} from "../../../../shared/decorators/pending.decorator";
import {DisposeMixin} from "../../../../shared/mixins/dispose.mixin";
import {LockMixin} from "../../../../shared/mixins/lock.mixin";
import {EmptyMixin} from "../../../../shared/mixins/empty.mixin";
import {ConfigurationService} from "../../../../shared/services/configuration.service";
import {WindowRefService} from "../../../../shared/services/window-ref.service";
import {LotNumberSearchForm} from "../../../forms/lot-number-search.form";
import {CofaWidgetConfigModel} from "../../../models/cofa-widget/cofa-widget-config.model";
import {LotNumberParamsModel} from "../../../models/cofa-widget/lot-number-params.model";
import {LotNumberResultItemModel} from "../../../models/cofa-widget/lot-number-result-item.model";
import {LotNumberDownloadItemModel} from "../../../models/cofa-widget/lot-number-download-item.model";
import {CofaWidgetService} from "../../../services/cofa-widget.service";
import {LotNumberService} from "../../../services/lot-number.service";

@Component({
    selector: "pcg-ng-lot-number-search-panel",
    template: require('./lot-number-search-panel.component.html')
})
export class LotNumberSearchPanelComponent extends DisposeMixin(LockMixin(EmptyMixin)) implements OnInit, OnDestroy {
    private changeSubscription: Subscription;
    private submitSubscription: Subscription;
    private formatSubscription: Subscription;

    @Pending
    private searchSubscription: Subscription;

    public config: CofaWidgetConfigModel;

    public searchForm: LotNumberSearchForm;
    public searchResult: LotNumberResultItemModel;

    public canRequest: boolean = false;
    public canDownload: boolean = false;

    public showDownloadUrls: boolean = false;
    public downloads: Array<LotNumberDownloadItemModel>;

    public constructor(
        private windowService: WindowRefService,
        private formBuilder: FormBuilder,
        private configService: ConfigurationService<CofaWidgetConfigModel>,
        private searchService: LotNumberService,
        private cofaWidgetService: CofaWidgetService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.config = this.configService.config;

        let params = new LotNumberParamsModel();
        this.searchForm = LotNumberSearchForm.createForm(this.formBuilder, params);

        this.changeSubscription = this.searchForm.changeObservable
            .subscribe(() => this.handleChange());

        this.submitSubscription = this.searchForm.submitObservable
            .subscribe((params: LotNumberParamsModel) => this.runSearch(params));

        this.formatSubscription = this.searchForm.formatId.valueChanges.subscribe(
            (value: string) => this.canRequest = !!this.searchForm.lotNumber.value
        );
    }

    public ngOnDestroy(): void {
        this.dispose();
    }

    public handleApplyClick(): void {
        this.searchForm.submit();
    }

    public handleRequestClick(): void {
        this.showDownloadUrls = false;
        this.cofaWidgetService.setLotNumber(this.searchForm.lotNumber.value);
        this.cofaWidgetService.setRequestMode();
    }

    public handleDownloadClick(): void {
        this.showDownloadUrls = false;
        if (!this.searchResult || !this.searchResult.downloads.length){
            return;
        }

        let urls = this.searchResult.downloads;
        if(urls.length == 1) {
            this.windowService.nativeWindow.location.href = this.searchResult.downloads[0].url;
        }
        else {
            this.showDownloadUrls = true;
            this.downloads = urls;
        }
    }

    private handleChange(): void {
        this.searchResult = null;
        this.canDownload = false;
        this.showDownloadUrls = false;
    }

    private runSearch(params: LotNumberParamsModel): void {
        params.vcpId = this.config.vcpId;
        this.searchSubscription = this.searchService.getSearchResult(params)
            .subscribe(
                (result: LotNumberResultItemModel) => {
                    this.searchResult = result || null;
                    this.canDownload = this.searchResult != null && this.searchResult.downloads.length > 0;
                    this.canRequest = !this.canDownload && this.searchForm.lotNumber.value != null && this.searchForm.lotNumber.value.length > 0;
                });
    }
}
